import camelCase from 'lodash-es/camelCase';
import isObject from 'lodash-es/isObject';
import { create, v, w } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/widgets/middleware/theme';
import { Title } from './title';
import { TableTgroup } from './table-tgroup';
import { knownClasses } from './table-util';
import css from '@holmescorp/book-widgets/css/topicpage.m.css';
const factory = create({ theme }).properties();
export const Table = factory(({ properties, middleware: { theme } }) => {
    const { topicdata } = properties();
    const themeCss = theme.classes(css);
    const data = topicdata;
    const { attributes = {} } = data;
    const jsonkids = data.children;
    const titleobj = jsonkids.find((kid) => isObject(kid) && 'title' in kid);
    const tgroups = jsonkids.filter((kid) => isObject(kid) && 'tgroup' in kid);
    const id = attributes.id;
    let outputclass = attributes.outputclass || null;
    if (outputclass) {
        outputclass = camelCase(outputclass);
        if (!knownClasses.has(outputclass)) {
            outputclass = null;
        }
    }
    const renderedTgroups = tgroups.map((tgroup) => {
        return w(TableTgroup, { tgroup: tgroup.tgroup, tableattrs: attributes });
    });
    return v('figure', { id, classes: [themeCss.figure, outputclass && themeCss[outputclass]] }, [
        titleobj ? w(Title, { title: titleobj, insection: true }) : null,
        ...renderedTgroups
    ]);
});
